"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcPaymentTransactionTypeSymbol = class UcPaymentTransactionTypeSymbol extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    transactionType;
    onTransaction_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("transactionType");
    }
    transactionTypes;
    ux;
    dataMembers = ['transactionTypes', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                transactionTypes: {
                    credit: {
                        icon: "mdi:plus-box",
                        tooltip: this.$fn.pgettext("PaymentType", "credit"),
                        color: "green",
                    },
                    debit: {
                        icon: "mdi:minus-box",
                        tooltip: this.$fn.pgettext("PaymentType", "debit"),
                        color: "red",
                    },
                    deposit: {
                        icon: "mdi:plus-box",
                        tooltip: this.$fn.pgettext("PaymentType", "deposit"),
                        color: "green",
                    },
                    payment: {
                        icon: "mdi:minus-box",
                        tooltip: this.$fn.pgettext("PaymentType", "payment"),
                        color: "red",
                    },
                    invoice_reconciliation: {
                        icon: "material-symbols:compare-arrows",
                        color: "blue",
                    },
                    write_off: {
                        icon: "material-symbols:arrow-right-alt",
                        color: "blue",
                    },
                },
                ux: null,
            },
        };
    }
    get bindings() {
        if (this.loaded) {
            return this.transactionTypes[this.transactionType || 'default'];
        }
        return null;
    }
    actions;
    getActions() {
        return {};
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcPaymentTransactionTypeSymbol.prototype, "transactionType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('transactionType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcPaymentTransactionTypeSymbol.prototype, "onTransaction_type", null);
UcPaymentTransactionTypeSymbol = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcPaymentTransactionTypeSymbol);
exports.default = UcPaymentTransactionTypeSymbol;
vue_property_decorator_1.Vue.component("UcPaymentTransactionTypeSymbol", UcPaymentTransactionTypeSymbol);
